export class AreaProlabQModel {
  public equivalent_profile_user: string;
  public notes: string;
  public type_profile: any;
}
